<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ titulo }}</h2>
        <span class="modal-subtitle">Informe o regime tributário para criar as naturezas de operação</span>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <div class="info-alert">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        <span>
            @switch (data.motivo) {
            @case ('semRegime') {
            Esta empresa ainda <strong>não possui regime tributário configurado</strong> em Configurações &rarr;
            Empresa. Informe o regime abaixo: ele será usado como base para criar as
            <strong>naturezas padrão</strong> e também será <strong>salvo no cadastro da empresa</strong>.
            }
            @case ('semApuracao') {
            Esta empresa está em Regime Normal, mas ainda <strong>não possui regime de apuração configurado</strong>
            em Configurações &rarr; Empresa. Confirme o regime abaixo: ele será usado como base para criar as
            <strong>naturezas padrão</strong> e também será <strong>salvo no cadastro da empresa</strong>.
            }
            @case ('regimeRecusado') {
            O regime tributário configurado em Configurações &rarr; Empresa
            <strong>não pôde ser usado</strong> para criar as naturezas de operação. Informe um regime válido
            abaixo: ele será usado como base para criar as <strong>naturezas padrão</strong> e também
            <strong>substituirá o regime no cadastro da empresa</strong>.
            }
            @default {
            <strong>Não foi possível consultar</strong> o regime tributário desta empresa em Configurações &rarr;
            Empresa. Informe o regime abaixo: ele será usado como base para criar as
            <strong>naturezas padrão</strong>, mas <strong>não será salvo no cadastro da empresa</strong>.
            }
            }
        </span>
    </div>

    <p class="hint-text">
        As naturezas poderão ser revisadas e editadas depois.
    </p>

    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Regime tributário</mat-label>
        <mat-select [value]="regimeTributarioSelecionado" (selectionChange)="selecionarRegimeTributario($event.value)">
            @for (regimeTributario of regimesTributarios; track regimeTributario.id) {
            <mat-option [value]="regimeTributario.id">{{ regimeTributario.codigo }} - {{ regimeTributario.descricao }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    @if (isRegimeNormal) {
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Regime apuração</mat-label>
        <mat-select [value]="regimeApuracaoIrpjSelecionado" (selectionChange)="regimeApuracaoIrpjSelecionado = $event.value">
            @for (regimeApuracaoIrpj of regimesApuracaoIrpj; track regimeApuracaoIrpj.id) {
            <mat-option [value]="regimeApuracaoIrpj.id">{{ regimeApuracaoIrpj.descricao }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
    }

    @if (data.gravarNoCadastro) {
    <div class="hint-text hint-text--icone">
        <mat-icon class="material-symbols-outlined">save</mat-icon>
        <span>
            Ao confirmar, o regime informado passa a constar em
            <strong>Configurações &rarr; Empresa &rarr; Dados Fiscais</strong> e esta pergunta não será exibida
            novamente para esta filial.
        </span>
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-flat-button class="btn-primary" type="button" [disabled]="!podeConfirmar" (click)="confirmar()">
        Confirmar
    </button>
</mat-dialog-actions>
